module.exports = __webpack_public_path__ + "media/images/brand/instagram_link-cae6903df09ee3f6722350983587738f.svg";